// extracted by mini-css-extract-plugin
export default {"button":"AddConditionButton_button__0hgzA","major":"AddConditionButton_major__65gYF","colored":"AddConditionButton_colored__+hoMB"};